import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
// import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import FAQS from "../../../MyComponents/FooterPages/newfaq"
import heroContent from "../HeroContent-CDesign";
import leftimgs from "../../../assets/gameleftimg.png";
import rightimgs from "../../../assets/gamerightimg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import FunActivities from "../../../MyComponents/FunActivities";
import BenefitsDataImg1 from "../../../assets/Game-benefit-img1.png";
import BenefitsDataImg2 from "../../../assets/Game-benefit-img2.png";
import BenefitsDataImg3 from "../../../assets/Game-benefit-img3.png";
import BenefitsDataImg4 from "../../../assets/Game-benefit-img4.png";
import BenefitsDataImg5 from "../../../assets/Game-benefit-img5.png";
import BenefitsDataImg6 from "../../../assets/Game-benefit-img6.png";
import BenefitsDataImg7 from "../../../assets/Game-benefit-img7.png";
import BenefitsDataImg8 from "../../../assets/Game-benefit-img8.png";
import BenefitsDataImg9 from "../../../assets/Game-benefit-img9.png";
import FunactivitiesImg1 from "../../../assets/GameFun-img1.png";
import FunactivitiesImg2 from "../../../assets/GameFun-img2.png";
import FunactivitiesImg3 from "../../../assets/GameFun-img3.png";
import FunactivitiesImg4 from "../../../assets/GameFun-img4.png";
import FunactivitiesImg5 from "../../../assets/GameFun-img5.png";
import LearningStyle from "../../../MyComponents/LearningStyle";
import HeadSection from "../../HeadSection.js";
import pencilIcon from "../../../assets/pencil.png";

import Testimonials from "../../../MyComponents/Testimonials";
 const beginnerModules = [
    {
      title: "Module 1",
      activities: "09",
      classes: "06",
      description: " Fundamentals of Game Development - Learn basic game development concepts, character movement, and effects.",
    },
    {
      title: "Module 2",
      activities: "09",
      classes: "05",
      description: ": Simple Games-  Create and customize simple games using templates, conditions, and loops.",
    },
    {
      title: "Module 3",
      activities: "07",
      classes: "04",
      description:": Arcade Games-  Build multiplayer arcade games with physics and scoring logic.",
    },
    
  ];

  const advancedModules = [
    {
      title: "Module 1",
      activities: "09",
      classes: "06",
      description:"  Gaming Concepts-  Learn to build interactive games using conditions, loops, movement, and scoring.",
    },
    {
      title: "Module 2",
      activities: "09",
      classes: "05",
      description:"Advanced Gaming Concepts - Create complete games using variables, events, and interface design.",
    },
    {
      title: "Module 3",
      activities: "09",
      classes: "05",
      description:": Multi-Level Games-  Design games with multiple levels and transitions using advanced Scratch concepts.",
    },
   
  ];


  const benefitsData = [
      {
        title: "Learn Coding Basics",
        description: "Start with fundamental programming concepts.",
        icon: "Polymath-images/Game-benefit-img1.png", //ji
      },
      {
        title: "Understand Game Development",
        description: "Discover how games are created and structured.",
        icon: "Polymath-images/Game-benefit-img2.png",
      },
      {
        title: "Boost Creativity",
        description: "Unleash your imagination through game design.",
        icon: "Polymath-images/Game-benefit-img3.png",
      },
      {
        title: "Enhance Storytelling Skills",
        description: "Create engaging stories and characters.",
        icon: "Polymath-images/Game-benefit-img4.png",
      },
      {
        title: "Build Real Projects",
        description: "Design and develop playable games.",
        icon: "Polymath-images/Game-benefit-img5.png",
      },
      {
        title: "Explore Game Design Concepts",
        description: "Learn core principles like mechanics and levels.",
        icon: "Polymath-images/Game-benefit-img6.png",
      },
      {
        title: "Use Multiple Game Platforms",
        description: "Work with various tools and engines.",
        icon: "Polymath-images/Game-benefit-img7.png",
      },
      {
        title: "Develop Problem-Solving Skills",
        description: "Strengthen logic through game challenges.",
        icon: "Polymath-images/Game-benefit-img8.png",
      },
      {
        title: "Build Custom Games",
        description: "Personalize games with unique features.",
        icon: "Polymath-images/Game-benefit-img9.png",
      },
    ];
    const activitiesData = [
        {
          title: "Basket Ball Game",
          image: "Polymath-images/GameFun-img1.png",
        },
        {
          title: "Dragon Land Game",
          image: "Polymath-images/GameFun-img2.png",
        },
        {
          title: "MineCraft Game",
            image: "Polymath-images/GameFun-img3.png",
        },
        {
          title: "Multiplayer Soccer Game",
          image: "Polymath-images/GameFun-img4.png",
        },
        {
          title: "Super Jumper Game",
          image: "Polymath-images/GameFun-img5.png",
        },
      ];
     const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how kids can turn their creativity into stunning designs! In this video, we’ll introduce fun tools, basic design tips, and exciting projects like logos, flyers, and digital art. Whether you're just starting out or love being creative, this is the perfect place to begin your design journey.",

      
    videoSrc: "", // Replace with the actual video URL
  };
const GameDevelopment = () => {
  const Scratchpage = heroContent.gamesection;
  return (
    <>
       {/* <GuestNav/> */}
     <HeadSection
      leftImg={'Polymath-images/gameleftimg.png'}
      rightImg={'Polymath-images/gamerightimg.png'}
      titlePart1="Game Development"
      titlePart2="Course"
      description="Kids love to play games. To Nurture Brainiacs and introduce young minds to the world of coding games, Polymath-Kids offers a comprehensive Game Development Course for kids. Polymath-Kids specialized Game Development Course help a child think out of the box by boosting the child's thinking and cognitive skills. Imagine your child creating their own exciting games!"
      button1Text= {false}
      button2Text="Book Free Demo Class"
      button1Icon={'Polymath-images/pencil.png'}
      button2Icon={'Polymath-images/pencil.png'}
      onButton1Click={() => alert("Early bird discount clicked!")}
      onButton2Click={() => alert("Book demo clicked!")}
    />
       <CourseTimeline
              title1="Course Structure & Syllabus"
              title="Beginner Level Course"
              modules={beginnerModules}
            />
            <CourseTimeline
             
              title="Advance Level Course"
              modules={advancedModules}
            />
       <Benefits
        title="How Students Can Benefit From Abacus"
        benefitsData={benefitsData}
      />
       <FunActivities
              mainTitle="Learn Kidprenur Course"
              subTitle="With 40+ Fun Activities"
              activities={activitiesData}
            />
        <LearningStyle/>
         
      <Testimonials/>
      <FAQS/>
       <Footer/>
    </>
  )
}
export default GameDevelopment